import ms from 'ms'

import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { memoizeIndexedDB } from '@new/__global/components/FastTapeChart/__utils'

export default {
  getJurisdictions: memoizeIndexedDB(
    'getJurisdictionsWithAssignedPropertyCount',
    async () => {
      return arriereBackoffice.queries.jurisdictions({
        __alias: 'getJurisdictions',
        __args: { page: 1, pageSize: 9999 },
        totalCount: true,
        items: {
          id: true,
          jurisdiction: true,
          assignedPropertyCount: true,
        },
      })
    },
    ms('6 hours'),
  ),
}
